<script>
import Navbar from '../components/Navbar';
import DealCard from '../components/DealCard';
import CategoriesFilter from '../components/CategoriesFilter';
import RetailersFilter from '../components/RetailersFilter';
import Loader from '../components/Loader';
import TopOffers from '../components/TopOffers';
import Footer from '../components/Footer';
import SideLeaderboards from '../components/SideLeaderboards';
import TrendingTopLatest from '../components/TrendingTopLatest';

export default {
    components: {
        Footer,
        Loader,
        Navbar,
        DealCard,
        TopOffers,
        RetailersFilter,
        CategoriesFilter,
        SideLeaderboards,
        TrendingTopLatest,
    },

    props: {
        typeFilter: String,
    },

    metaInfo: {
        title: 'Share a great deal, earn a great deal',
    },

    data() {
        return {
            isScrollDisabled: false,
        };
    },

    async mounted() {
    

        if (!this.$route.query.resetRetailers) {
            this.$store.commit('resetRetailersFilter');
        }

        if (!this.$route.query.resetCategories) {
            this.$store.commit('resetCategoriesFilter');
        }

        if (this.$route.query.search) {
            this.$store.dispatch('searchFilter', this.$route.query.search);
        } else {
            this.$store.commit('resetSearchFilter');
        }

        if (this.$route.query.retailer) {
            this.$store.dispatch('toggleRetailersFilter', this.$route.query.retailer);
            // this.$store.dispatch('debounceDeals');
        }

        this.$store.commit('setTypeFilter', this.typeFilter);
        if (this.$route.query.category) {
            let activeFilters = {no: true};
            let categories = JSON.parse(this.$route.query.category);
            for (let elem of categories) {
                activeFilters[elem] = true;
            }
            this.$store.dispatch('toggleCategoriesFilter', Object.keys(activeFilters));
        } else {
            this.$store.commit('resetDealsPagination');
        }


        if (this.$route.query.thankYouForVerifyingYourEmail) {
            Vue.toasted.show(
                'Thank you for verifying your email. You may now continue to post amazing deals!',
                { duration: 6000, icon: 'check' },
            );
        }

        if (this.$route.query.passwordChanged) {
            Vue.toasted.show(
                'Your password was successfully changed. Log in with your new password to start sharing deals',
                { duration: 6000, icon: 'check' },
            );
        }

        if (this.$route.query.facebookRedirect) {
            this.$store.dispatch('tokenLogin', this.$route.query.facebookRedirect);
        }

        if (this.$route.query.nu) {
            Vue.toasted.show(
                'You have been successfully unsubscribed from the Daily Newsletter',
                { duration: 6000, icon: 'check' },
            );
        }

        await this.$store.dispatch('getDeals');

        // Scroll to top after deals loaded
        window.scrollTo(0, 0);
    },

    methods: {
        loadMore() {
            if (this.$store.state.deals.isFinished) return;
            if (this.$store.state.deals.isLoading) return;

            this.$store.dispatch('getDeals');
        }
    },


};
</script>

<template lang='pug'>
.page-wrapper
    Navbar

    .content-wrapper
        .menu-wrapper
            categories-filter
            retailers-filter

        .deal-area-wrapper
            TopOffers
            TrendingTopLatest

            .deals-wrapper
                DealCard(
                    v-for='deal in this.$store.state.deals.filtered'
                    :key='deal.id'
                    :deal='deal')

                span(v-if='this.$store.state.deals.filtered.length == 0 && !this.$store.state.deals.isLoading && this.$store.state.deals.isFinished').no-deals
                    |No Deals to display

            Loader(v-if='this.$store.state.deals.isLoading')

            .deals-end(v-if="!this.$store.state.deals.isFinished && !this.$store.state.deals.isLoading")
                button.loadmore(@click="loadMore()") Load More
            .deals-end(v-if="this.$store.state.deals.isFinished && this.$store.state.deals.filtered.length != 0")
                | You've reached the end!

        .leaderboard-wrapper
            SideLeaderboards

    Footer
</template>

<style lang='stylus' scoped>
    @import "../../stylus/mixins.styl";
    @import "../../stylus/variables.styl";

    .content-wrapper
        display flex
        flex-direction row

        @media (max-width: 1300px)
            flex-direction column

        .menu-wrapper
            min-width 350px
            max-width 350px

            @media (max-width: 1300px)
                min-width 0px
                max-width 100%

        .deal-area-wrapper
            display-flex(column)
            flex-grow 1

            .loader
                align-self center

            .deals-wrapper
                display-flex(row)
                align-items center
                flex-wrap wrap
                justify-content space-evenly

                span.no-deals
                    padding 30px 20px
                    font-weight bold

            .deals-end
                align-self center
                padding 30px 20px
                font-weight bold

                button.loadmore
                    padding 10px 20px
                    background-color $dark-green
                    border-radius: 15px
                    color white

        .leaderboard-wrapper
            margin 58px 87px 58px 87px
            min-width 350px
            max-width 350px

            @media(max-width: 1700px)
                display: none
</style>
